import Cookies from 'js-cookie'
import { MarketoPayload, SyncariPayload } from '@common/state/marketing/state'

// Replace empty string and undefined with null
export function sanitizePayload<T extends Record<string, any>>(payload: T): T {
    return Object.entries(payload).reduce((acc, [key, value]) => {
        acc[key as keyof T] = value === '' || value === undefined ? null : value
        return acc
    }, {} as T)
}

function isLMIProduct(payload: any) {
    return (
        payload.product &&
        (payload.product.toLowerCase() === 'pro' ||
            payload.product.toLowerCase() === 'logmeinpro' ||
            payload.product.toLowerCase() === 'central' ||
            payload.product.toLowerCase() === 'logmeincentral')
    )
}

export function fetchCampaignOverrideCookie() {
    return (
        Cookies.get('__lt_campaigniD') ||
        Cookies.get('__lt_campaignId') ||
        Cookies.get('__lt_campaignID') ||
        Cookies.get('__lt_campaignid')
    )
}

export function buildSyncariPayload(payload: any) {
    const syncariPayload: SyncariPayload = {
        userKey: payload.userKey,
        accountKey: payload.accountKey,
        email: payload.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        planKey: payload.planKey,
        productTier: payload.productTier,
        product: payload.product,
        mkto_trk: payload.mkto_trk,

        UnsubscribedTemp: payload.optin === '0' ? 'true' : 'false',
        Temp_Country__c: payload.country,
        Language__c: payload.language,
        Most_Recent_Campaign__c: payload.campaignID,
        recentChopId: payload.chop_id,
        recentgclid: payload.gclid,
        utm_medium: payload.utmmedium,
        utm_source: payload.utmsource,
        utm_campaign: payload.utmcampaign,
        personSourceURL: payload.sourceUrl,
        contentStage: payload.contentStage || '',
        userreferrer: payload.userreferrer,
        form_Id: payload.form_Id || 'purchaseForm',
    }

    if (isLMIProduct(payload)) {
        syncariPayload.product = 'LMI'
    }

    return syncariPayload
}

export function preprocessMarketoPayload(payload: MarketoPayload) {
    const prepPayload: { [key: string]: any } = { ...payload }

    // Extract and add Marketo attributes if they exist
    const marketoAttributesFieldName = 'lmi_ma'
    if (prepPayload[marketoAttributesFieldName]) {
        const marketoAttributeFields = prepPayload[marketoAttributesFieldName].split('|')

        marketoAttributeFields.forEach((field: any) => {
            const [key, value] = field.split('=')
            if (key && value) {
                const decodedKey = decodeURIComponent(key)
                const decodedValue = decodeURIComponent(value)
                if (decodedKey === 'campaignID' && prepPayload.campaignID) {
                    delete prepPayload.campaignID
                }
                prepPayload[decodedKey] = decodedValue
            }
        })
        delete prepPayload[marketoAttributesFieldName]
    }

    // Set blank values for missing optional fields
    const blankFieldsIfExcluded = ['userreferrer', 'campaignsource', 'utmsource', 'utmmedium', 'utmcampaign']
    blankFieldsIfExcluded.forEach((field) => {
        if (!prepPayload[field]) prepPayload[field] = ''
    })

    const overrideCampaignID = fetchCampaignOverrideCookie()
    if (overrideCampaignID) {
        prepPayload.campaignID = overrideCampaignID
    }

    return prepPayload
}
